import { render, staticRenderFns } from "./BuyOrderImport.vue?vue&type=template&id=8a9d58fe&scoped=true"
import script from "./BuyOrderImport.vue?vue&type=script&lang=js"
export * from "./BuyOrderImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9d58fe",
  null
  
)

export default component.exports